import { StringSchema } from "yup";

import { string } from "./general.RHF";

export const wishlistName = string().nullable().required().max(25);

export const optionalWishlistName = string().nullable().max(25);

export const wishListTargetId = string().nullable().required();

export const conditionalWishlistName = string().when("targetId", {
    is: (val: string) => val === "new",
    then: (schema: StringSchema) => schema.nullable().required(),
    otherwise: (schema: StringSchema) => schema.nullable().notRequired()
});
